// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header--tuqTx{top:-20px;z-index:1;margin:-20px -24px 8px;padding:20px 24px 16px;border-bottom:1px solid #f0f0f4}.header-controls--D1r9z{gap:12px;margin-top:12px}.skill-list--iq3K0{gap:12px}.skill-tile--OefNv{border:1px solid #f0f0f4}.skill-toggle--YoU8u{margin-top:2px}.skill-name--hevMC{font-size:15px}.skill-kind-badge--Pjtfi{display:inline-block;padding:2px 8px;border-radius:999px;font-size:11px;font-weight:600;line-height:1.4;vertical-align:text-bottom}.skill-kind-video--WhkFY{background:#eeecfe;color:#2a1ac2}.skill-kind-howto--qwF0g{background:#f0f0f4;color:#5a6272}.skill-kind-label--nujVX{font-size:13px;font-weight:600}.skill-kind-hint--tV6V0{font-size:12px}.skill-id--Z0XVj{font-size:12px}.skill-description--AGZ31{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;line-height:1.4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "header--tuqTx",
	"header-controls": "header-controls--D1r9z",
	"skill-list": "skill-list--iq3K0",
	"skill-tile": "skill-tile--OefNv",
	"skill-toggle": "skill-toggle--YoU8u",
	"skill-name": "skill-name--hevMC",
	"skill-kind-badge": "skill-kind-badge--Pjtfi",
	"skill-kind-video": "skill-kind-video--WhkFY",
	"skill-kind-howto": "skill-kind-howto--qwF0g",
	"skill-kind-label": "skill-kind-label--nujVX",
	"skill-kind-hint": "skill-kind-hint--tV6V0",
	"skill-id": "skill-id--Z0XVj",
	"skill-description": "skill-description--AGZ31"
};
export default ___CSS_LOADER_EXPORT___;
